type CollectionItemType = {
  position?: number;
};

const sortCollectionItems = <T extends CollectionItemType>(
  collectionItemA: T,
  collectionItemB: T,
) => {
  if (
    typeof collectionItemA.position !== 'undefined' &&
    typeof collectionItemB.position === 'undefined'
  ) {
    return -1;
  }
  if (
    typeof collectionItemA.position === 'undefined' &&
    typeof collectionItemB.position !== 'undefined'
  ) {
    return 1;
  }
  return (collectionItemA.position || 0) - (collectionItemB.position || 0);
};

export default sortCollectionItems;
